/**
 * @author: howarchou@sina.com
 * @date: 2018/11/4
 */
import Pop from "./Pop";

var vuePop = {}, VPop, _pop;

vuePop.install = function (Vue, options) { // vue的install方法，用于定义vue插件
    // 如果toast还在，则不再执行
    if (_pop || document.getElementsByClassName('pop-wrap').length) {
        return
    }
    create();
    function create() {
        VPop = Vue.extend(Pop);
        _pop = new VPop();
        // 手动创建一个未挂载的实例
        _pop.$mount();
        // 挂载
        document.querySelector('body').appendChild(_pop.$el)
        return _pop;
    }

    Vue.prototype.$pop = { // 在Vue的原型上添加实例方法，以全局调用
        confirm(...args) {
            let arr = [...args], ok, opt = arr[1];
            if (!opt) opt = {};
            typeof opt == 'function' && (ok = opt, opt = {ok});
            if (!opt['btns']) opt['btns'] = ['确定', '取消'];
            arr[1] = opt;
            _pop.open(...arr)
        },
        alert(...args) {
            _pop.open(...args);
        }
    }
}
export default vuePop



// WEBPACK FOOTER //
// ./src/components/pop/index.js